import React from 'react';
import { Input } from 'antd';
import type { SearchProps } from 'antd/es/input';

export const InputSearch: React.FC<SearchProps> = (props) => {
  return <Input.Search {...props} />;
};
